import * as React from "react";
function SvgChevronUp(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <g clipPath="url(#chevron-up_svg__clip0_2_3023)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.707 7.293l8 8-1.414 1.414L12 9.414l-7.293 7.293-1.414-1.414 8-8a1 1 0 011.414 0z"
                    fill="currentcolor"
                />
            </g>
            <defs>
                <clipPath id="chevron-up_svg__clip0_2_3023">
                    <path fill="#fff" d="M0 0h24v24H0z" />
                </clipPath>
            </defs>
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgChevronUp);
export default ForwardRef;
